import Cookies from 'js-cookie';

export const getAnonUser = () => {
  const pianoUid = Cookies.get('pianoUid');
  if (pianoUid) return pianoUid;
  const anonUser = Cookies.get('anonUserOptimizely') || Math.random().toString(36).substr(2, 9);
  Cookies.set('anonUserOptimizely', anonUser);
  return anonUser;
};

export const OPTIMIZELY_EVENT_VALUES = {
  inContentAd0: 1.6,
  inContentAd1: 1.4,
  inContentAd2: 1.6,
  inContentAd3: 1.7,
  inContentAd4: 1.6,
  inContentAd5: 1.5,
  inFeedAd0: 7,
  inFeedAd1: 8,
  inFeedAd2: 7.2,
  inFeedAd3: 6.8,
  inFeedAd4: 6.9,
  inFeedAd5: 0.7,
  leaderboardTop: 1.7,
  siderailFlex1: 4.5,
  siderailFlex2: 5.9,
  siderailSticky: 3.7,
  newsletterSubscription: 300,
  defaultAdImpression: 2,
  finishedArticle: 10,
};
